import { render, staticRenderFns } from "./ArticleCategories.vue?vue&type=template&id=7336d558&scoped=true"
import script from "./ArticleCategories.vue?vue&type=script&lang=js"
export * from "./ArticleCategories.vue?vue&type=script&lang=js"
import style0 from "./ArticleCategories.vue?vue&type=style&index=0&id=7336d558&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7336d558",
  null
  
)

export default component.exports